var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-6-scenario',{attrs:{"page":8,"scenario":'scenario2'}})}
var staticRenderFns = []

export { render, staticRenderFns }